<template>
    <div class="popup" v-on:click="hideMe()">
		<span class="popuptext" id="myPopup">
			<p>Wprowadzone przez Ciebie dane zostały już zarejestrowane w naszym systemie. W celu ich zmiany skontaktuj się z działem Call Center pod numerem telefonu:<br><span class="color-blue">(22) 307 68 98.</span> </p>
			<i class="ion-android-close"></i>
		</span>
    </div>

</template>

<script>
    export default {
        name: 'finishedOrderPopup',
        props: ["step"],
        data () {
            return {

            }
        },
        methods: {
            hideMe: function() {
                this.$emit('setFinishedOrderPopup', false);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// FinishedOrderPopup.vue?1d064670